import { defineMessages } from 'react-intl';

export const messages: {
	groupInfoButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	groupInfoButton: {
		id: 'admin-hub-select-list.group-info-button',
		defaultMessage: 'Info button for {groupName}',
		description:
			'Accessible label for the info button associated with a select list group. The placeholder {groupName} is substituted with the name of the group.',
	},
});
